import { Fragment } from "react";
import { type Merge } from "type-fest";

import { css, cx } from "#styled-system/css";

const SKELETON_SCREEN_STYLE = css.raw({
  animation: "skeleton-screen-b 1s ease-in-out",
  backgroundColor: "lightgray",
  color: "transparent",
  display: "inline-block",
  minHeight: 0,
  minWidth: 0,
  opacity: 0.5,
  overflow: "clip",
  position: "relative",
  userSelect: "none",

  _before: {
    animation: "skeleton-screen-a 1.6s ease-in-out infinite",
    background: "linear-gradient(90deg, transparent, white 40%, white 60%, transparent)",
    content: '""',
    position: "absolute",
    inset: 0,
  },
});

export function SkeletonScreen({
  children,
  className,
  disabled,
  ...properties
}: Merge<React.ComponentProps<"span">, { disabled?: boolean }>) {
  return disabled ? (
    <Fragment>{children}</Fragment>
  ) : (
    <span {...properties} className={cx(css(SKELETON_SCREEN_STYLE), className)}>
      {children}
    </span>
  );
}

/** @deprecated 代わりに`SKELETON_SCREEN_STYLE`または`SkeletonScreen`を使用する。 */
export const skeletonStyle = css.raw({
  _empty: {
    backgroundColor: "lightgray",
    display: "inline-block",
    fontSize: "inherit",
    letterSpacing: "inherit",
    lineHeight: "inherit",
    opacity: 0.25,
    overflow: "clip",
    position: "relative",

    _before: {
      animation: "horizontal-skeleton 1.5s linear infinite",
      background: "linear-gradient(90deg, transparent, white, transparent)",
      content: '""',
      display: "block",
      position: "absolute",
      inset: 0,
    },
  },
});
